import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useCount } from 'modules/quickActionsMenu/hooks';
import { SetCount } from 'modules/quickActionsMenu/types';
import { Handlebars16 } from 'ui/icons';
import { Spinner } from 'ui/spinner';
import { Item } from '../Item';
import { CommandGroup, CommandLoading, EmptyState } from '../Styled';
import { useSnippetSearch } from './useSnippetSearch';

export const SNIPPET_SEARCH_TEXT = {
  heading: 'Snippets',
  emptyStateMessage: 'Snippet search results placeholder',
};

const { emptyStateMessage, heading } = SNIPPET_SEARCH_TEXT;

export const SnippetSearch = ({ setCount }: { setCount: SetCount }) => {
  const { navigate } = useQuickActionsMenuContext();
  const { isLoading, paginationInfo, snippets } = useSnippetSearch();
  useCount({ count: paginationInfo?.count, setCount });

  if (isLoading) {
    return (
      <CommandLoading>
        <Spinner />
      </CommandLoading>
    );
  }

  return (
    <>
      {snippets.length === 0 ? (
        <EmptyState>{emptyStateMessage}</EmptyState>
      ) : (
        <CommandGroup heading={heading}>
          {snippets.map((snippet) => (
            <Item
              Icon={<Handlebars16 />}
              id={snippet.id}
              key={snippet.id}
              name={snippet.name}
              onSelect={() =>
                navigate({
                  id: snippet.id,
                  pageName: 'Snippet details page',
                  path: `/templates/snippet/${snippet.id}/edit`,
                })
              }
              value={`${snippet.name} ${snippet.id}`}
            />
          ))}
        </CommandGroup>
      )}
    </>
  );
};
